import { PRODUCTION_ENV, STAGING_ENV } from '~/constants'
import {
  ECampaignContactDefaultMergeFields,
  EAdminOrgsBillingModeFilter,
  EGetCheckoutLinkProduct,
  TGetCheckoutLinkProductIds,
} from '~/features/admin/models'
import { TMergeField } from '~/features/campaigns/models'

export const MAX_RECENT_LOGIN_AS_USERS = 10

// Must match SEARCH_LIMIT in replifyAdmin services/admin/src/services/agent.ts.
export const ADMIN_AGENTS_SEARCH_LIMIT = 100

export const CREATE_NEW_ORG_USER_NAME_MAX_LENGTH = 255
export const CREATE_NEW_ORG_ORGANIZATION_NAME_MAX_LENGTH = 255

export const INTERNAL_ACCOUNT_CANNOT_DOWNGRADE_MESSAGE =
  'This is an internal account that cannot be downgraded. If you believe it should be downgraded, please email engineering-admin@replify.ai.'

export const INTERNAL_ACCOUNT_CANNOT_DOWNGRADE_TOAST_ID =
  'internalAccountCannotDowngrade'

export const ADMIN_ORGS_BILLING_MODE_OPTIONS = [
  { label: 'All billing modes', value: EAdminOrgsBillingModeFilter.all },
  { label: 'Paid', value: EAdminOrgsBillingModeFilter.paid },
  { label: 'Internal', value: EAdminOrgsBillingModeFilter.internal },
  { label: 'Inactive', value: EAdminOrgsBillingModeFilter.inactive },
  { label: 'Demo', value: EAdminOrgsBillingModeFilter.demo },
]

export const GET_CHECKOUT_LINK_PRODUCT_ID: TGetCheckoutLinkProductIds = {
  [PRODUCTION_ENV]: {
    [EGetCheckoutLinkProduct.basic]: 'prod_PYVkJN8VfnUA17',
    [EGetCheckoutLinkProduct.plus]: 'prod_PYVkUj9ubd4NWN',
  },
  [STAGING_ENV]: {
    [EGetCheckoutLinkProduct.basic]: 'prod_PekqVRb2l4BC4j',
    [EGetCheckoutLinkProduct.plus]: 'prod_PeksTOZCEsUHxW',
  },
}

export const DEFAULT_CAMPAIGN_TEMPLATE_ID = 'newTemplate'

export const DEFAULT_MERGE_FIELDS: TMergeField[] = [
  {
    friendlyName: 'First Name',
    required: true,
    variable: ECampaignContactDefaultMergeFields.firstName,
  },
  {
    friendlyName: 'Last Name',
    required: true,
    variable: ECampaignContactDefaultMergeFields.lastName,
  },
  {
    friendlyName: 'Phone Number',
    required: true,
    variable: ECampaignContactDefaultMergeFields.phone,
  },
  {
    friendlyName: 'Email',
    required: true,
    variable: ECampaignContactDefaultMergeFields.email,
  },
]
